import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'tanok';
import { getRoom } from '@evo/chat-core';
import { getSocketStore } from './../../../libs/utils';
import * as c from './../../../libs/constants';

import { Header } from './header';
import { Body } from './body';
import { Ban } from './ban';
import { Unban } from './unban';

import { Spinner } from '../../ui/spinner';
import { Layout } from '../../ui/layout';

import { toJS } from '../../helpers/ImmutableToJS';

// styles
import css from './company.sss';


const CompanyBanView = (props) => {
    const { isLoadingData, activeCompanyTab, closeDialog, modifiedCompanyRoom } = props;

    return (
        <Layout key='containerBesida' dataQa='besida_panel_block'>
            <Layout.Header>
                <Header closeDialog={closeDialog} />
            </Layout.Header>
            <Layout.Body>
                {isLoadingData.companyInfo ? (
                    <Spinner />
                ) : (
                    <div className={css.root}>
                        <Body />
                        {activeCompanyTab === c.CHAT_COMPANY_BAN && (
                            <Ban />
                        )}
                        {modifiedCompanyRoom.companyBanned && (
                            <Unban />
                        )}
                    </div>
                )}
            </Layout.Body>
        </Layout>
    );
};

CompanyBanView.propTypes = {
    isLoadingData: PropTypes.object,
    activeCompanyTab: PropTypes.string,
    closeDialog: PropTypes.func,
};

const mapStateToProps = (state) => {
    const socketStore = getSocketStore(state);
    const modifiedCompanyRoom = getRoom(socketStore, state.get('prevOpenedRoomIdent'));

    return {
        isLoadingData: state.get('isLoadingData'),
        activeCompanyTab: state.get('activeCompanyTab'),
        locale: state.get('locale'),
        modifiedCompanyRoom
    };
};

export const CompanyBan = connect(mapStateToProps)(toJS(CompanyBanView));
